import React from 'react';
import FilterList from 'components/FilterList';
import Graph from 'components/Graph';
import { KpiElement } from './KpiElement';
import { KpiElementTable } from './KpiElementTable';
import { AccordionWrapper, MainContent, GraphWrapper, KpisArea } from './style';
import Accordion from 'components/Accordion';
import { AreaWithGroupedKpis, TextKpiBlock } from 'routes/ControlTower/interfaces';
import { KpiCategoryFilterConfiguration, KpiCategoryFilterValue } from 'models/request';

interface ListViewProps {
  dateTo?: string;
  dateFrom?: string;
  gbsList?: string[];
  companies?: string[];
  channels?: string[];
  types?: string[];
  categoryName?: string;
  areas?: AreaWithGroupedKpis[];
  categoryId: number;
  exportReport: (reportId: number) => Promise<void>;
  viewReport: (reportId: number) => Promise<void>;
  drillDownProtocols: (idMetric: number, idGeoList: any) => Promise<void>;
  kpiCategoryFilterValues?: KpiCategoryFilterValue[];
  kpiCategoryFilterConfig?: KpiCategoryFilterConfiguration[];
}

const ListView: React.FC<ListViewProps> = ({
  dateTo,
  dateFrom,
  gbsList,
  companies,
  channels,
  types,
  categoryName,
  areas,
  categoryId,
  exportReport,
  viewReport,
  drillDownProtocols,
  kpiCategoryFilterValues,
  kpiCategoryFilterConfig,
}) => {
  return (
    <>
      {areas?.map((area) => {
        const { name, idArea, kpisGrouped, average, showSummaryDetails, dateLabel } = area;
        const kpisMain = (kpisGrouped?.filter(({ type }) => type === 'text').slice(0, 2) as TextKpiBlock[]) || [];
        const kpisHidden = kpisGrouped?.slice(2) || [];

        return (
          <AccordionWrapper key={idArea}>
            <Accordion
              title={name}
              mainContent={
                <MainContent>
                  {kpisMain.map((item) => (
                    <KpiElement
                      key={item.kpi?.idMetric}
                      kpi={item.kpi}
                      categoryId={categoryId}
                      exportReport={exportReport}
                      viewReport={viewReport}
                      drillDownProtocols={drillDownProtocols}
                    />
                  ))}
                </MainContent>
              }
              disabled={!average?.result && !kpisHidden?.length}
              hiddenContent={
                <>
                  <div>
                    <FilterList
                      dateTo={dateTo}
                      dateFrom={dateFrom}
                      gbsList={gbsList}
                      companies={companies}
                      channels={channels}
                      types={types}
                      categoryName={categoryName}
                      kpiCategoryFilterValues={kpiCategoryFilterValues}
                      kpiCategoryFilterConfig={kpiCategoryFilterConfig}
                      showSummaryDetails={showSummaryDetails}
                      dateLabel={dateLabel}
                    />

                    <GraphWrapper>{average?.result && <Graph percentage={average.result} />}</GraphWrapper>
                  </div>

                  <KpisArea>
                    {kpisHidden.map((item) => {
                      switch (item.type) {
                        case 'grouped-table':
                          return (
                            <div
                              style={{
                                width: '100%',
                                display: 'grid',
                                gridTemplateColumns: '1fr 1fr',
                                gridColumnGap: '20px',
                              }}
                            >
                              {item.kpis.map((kpi) => (
                                <div key={kpi.idMetric}>
                                  <KpiElementTable
                                    kpi={kpi}
                                    categoryId={categoryId}
                                    exportReport={exportReport}
                                    viewReport={viewReport}
                                    drillDownProtocols={drillDownProtocols}
                                    variant="grouped"
                                  />
                                </div>
                              ))}
                            </div>
                          );

                        case 'table':
                          return (
                            <div style={{ width: '100%' }}>
                              <KpiElementTable
                                key={item.kpi.idMetric}
                                kpi={item.kpi}
                                categoryId={categoryId}
                                exportReport={exportReport}
                                viewReport={viewReport}
                                drillDownProtocols={drillDownProtocols}
                              />
                            </div>
                          );

                        case 'text':
                          return (
                            <KpiElement
                              key={item.kpi.idMetric}
                              kpi={item.kpi}
                              categoryId={categoryId}
                              exportReport={exportReport}
                              viewReport={viewReport}
                              drillDownProtocols={drillDownProtocols}
                            />
                          );

                        default:
                          return null;
                      }
                    })}
                  </KpisArea>
                </>
              }
            />
          </AccordionWrapper>
        );
      })}
    </>
  );
};

export default ListView;
